import { makeStyles } from '@fluentui/react-components';

export const useFooterStyles = makeStyles({
  footer: {
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

